import { createSelector } from 'reselect'
import getLoyaltyTransferItems from '../items/getLoyaltyTransferItems'
import getTransferItems from '../items/getTransferItems'
import { getAirportsByCode } from 'selectors/flightsSelectors'
import calculateDistance from 'lib/geo/distanceBetweenPoints'

const getUnifiedTransferView = createSelector(
  (state: App.State) => getLoyaltyTransferItems(state),
  (state: App.State) => getTransferItems(state),
  (state: App.State) => state.destination.googlePlaces,
  (state: App.State) => getAirportsByCode(state),
  (loyaltyTransfers, transferItems, googlePlaces, airportsByCode): App.WithDataStatus<App.Checkout.UnifiedTransferView> => {
    if (loyaltyTransfers.length > 0) {
      const transfer = loyaltyTransfers[0]
      const place = googlePlaces[transfer?.pickUpLocation]
      const airport = airportsByCode[transfer?.dropOffLocation]

      return {
        hasRequiredData: true,
        data: {
          transferType: 'HOME_TO_AIRPORT',
          hasTransfers: true,
          loyaltyTransfers,
          transferItems: [],
          distance: (place?.latitude && place?.longitude && airport?.latitude && airport?.longitude)
            ? calculateDistance(place.latitude, place.longitude, airport.latitude, airport.longitude)
            : undefined,
          isEditing: true,
          pickUpPlaceId: transfer?.pickUpLocation,
          dropOffAirportCode: transfer?.dropOffLocation,
          pickUpPlace: place,
          dropOffAirport: airport,
        }
      }
    }

    // Handle pure transfer items (new approach)
    if (transferItems.length > 0) {
      const loyaltyTransferItems = transferItems.filter(item => item.isLoyaltyTransfer)

      if (loyaltyTransferItems.length > 0) {
        const hasToHotel = loyaltyTransferItems.some(item => item.transfer.type === 'AIRPORT-TO-HOTEL')
        const hasToAirport = loyaltyTransferItems.some(item => item.transfer.type === 'HOTEL-TO-AIRPORT')

        let transferType: App.Checkout.UnifiedTransferView['transferType']

        if (loyaltyTransferItems.length === 2 && hasToHotel && hasToAirport) {
          transferType = 'FREE_RETURN_TRANSFER' // Assume both are free via loyalty
        } else if (hasToHotel) {
          transferType = 'ONE_WAY_ARRIVAL'
        } else if (hasToAirport) {
          transferType = 'ONE_WAY_DEPARTURE'
        }

        const firstTransferItem = loyaltyTransferItems[0]
        const transferOption = firstTransferItem.transfer.option
        return {
          hasRequiredData: true,
          data: {
            transferType,
            hasTransfers: true,
            loyaltyTransfers: [],
            transferItems: loyaltyTransferItems,
            isEditing: true,
            pickUpPlaceId: undefined,
            dropOffAirportCode: undefined,
            pickUpPlace: undefined,
            dropOffAirport: undefined,
            maxPassengers: transferOption?.maxPassengers,
            maxCheckedBags: transferOption?.maxCheckedBags,
            transferOption,
          }
        }
      }
    }

    return {
      hasRequiredData: false,
      data: {
        hasTransfers: false,
        loyaltyTransfers: [],
        transferItems: [],
        isEditing: false,
        pickUpPlaceId: undefined,
        dropOffAirportCode: undefined,
        pickUpPlace: undefined,
        dropOffAirport: undefined,
      }
    }
  }
)

export default getUnifiedTransferView
